export const isSandboxMode = () => process.env.REACT_APP_SANDBOX_MODE === "1";
export const getApiBaseUrl = () => process.env.REACT_APP_API_BASE_URL;
